import {
  cryptoUint32,
  pick,
  type Uint32Source,
} from "@/lib/tool-kit/random-fun/rng";

/** How many tries per requested name before the batch gives up on finding new ones. */
const MAX_ATTEMPT_MULTIPLIER = 20;

/** "Harper Harper": a first name and surname that are the same word. */
export function isSameWord(first: string, last: string): boolean {
  return first.toLowerCase() === last.toLowerCase();
}

/**
 * Up to `count` different "First Last" names. A pair whose two halves are the same word
 * is never produced: several modern first names (Harper, Mason, Parker) also sit on the
 * surname list, and "Parker Parker" reads as a mistake, not a name.
 */
export function generateNames(
  firstNames: readonly string[],
  lastNames: readonly string[],
  count: number,
  source: Uint32Source = cryptoUint32
): string[] {
  const seen = new Set<string>();
  const results: string[] = [];
  const maxAttempts = count * MAX_ATTEMPT_MULTIPLIER;
  for (
    let attempts = 0;
    results.length < count && attempts < maxAttempts;
    attempts += 1
  ) {
    const first = pick(firstNames, source);
    const last = pick(lastNames, source);
    const name = `${first} ${last}`;
    if (!(isSameWord(first, last) || seen.has(name))) {
      seen.add(name);
      results.push(name);
    }
  }
  return results;
}
